<template>
    <div>
        <!-- START SIDEBAR-->
        <nav class="page-sidebar" id="sidebar" >
            <div id="sidebar-collapse">
                <div class="admin-block d-flex">
                    <div>
                        <img src="" class="img-circle" width="45px"/>
                    </div>
                    <div class="admin-info">
                        <div class="font-strong"></div>
                        <small></small>
                    </div>
                </div>
                <ul class="side-menu metismenu" >
                    <li v-if="$store.getters.getAuth['userType'] === 'superuser' || dashboardVisibleCraftsmen " >
                        <router-link :to="{name: 'Dashboard'}" :disabled="true"><i
                                class="sidebar-item-icon fa fa-th-large"></i>
                            <span class="nav-label">{{$t('message.dashboard')}}</span>
                        </router-link>
                    </li>
                    <li v-if="$store.getters.getAuth['userType'] === 'craftsmen'">
                        <router-link :to="{name: 'CraftsmenDashboard'}" :disabled="true"><i
                                class="sidebar-item-icon fa fa-address-book"></i>
                            <span class="nav-label">{{$t('message.yourContracts')}}</span>
                        </router-link>
                    </li>
                    <li v-if="$store.getters.getAuth['userType'] === 'superuser'">
                        <router-link :to="{name: 'Reporting'}" :disabled="true"><i
                                class="sidebar-item-icon fa fa-bar-chart"></i>
                            <span class="nav-label">{{$t('message.reporting')}}</span>
                        </router-link>
                    </li>
                    <li class="heading">{{$t('message.features')}}</li>
                    <li>
                        <router-link v-if="$store.getters.getAuth['userType'] === 'superuser'" :to="{name: 'Projects'}">
                            <i class="sidebar-item-icon fa fa-edit"></i>
                            <span class="nav-label">{{$t('message.projects')}}</span>
                        </router-link>
                    </li>
                    
                    <!-- <li>
                        <router-link v-if="$store.getters.getAuth['userType'] === 'superuser'" :to="{name: 'Companies'}">
                            <i class="sidebar-item-icon fa fa-building-o"></i>
                            <span class="nav-label">{{$t('message.companies')}}</span>
                        </router-link>
                    </li> -->
                    <li v-if="$store.getters.getAuth['userType'] === 'superuser'">
                        <router-link :to="{name: 'Contacts'}"><i class="sidebar-item-icon fa fa-phone"></i>
                            <span class="nav-label">{{$t('message.contacts')}}</span></router-link>
                    </li>
                    <li>
                        <router-link v-if="$store.getters.getAuth['userType'] === 'superuser'" :to="{name: 'Tasks'}" :disabled="true"><i
                                class="sidebar-item-icon fa fa-bell"></i>
                            <span class="nav-label">{{$t('message.tasks')}}</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$store.getters.getAuth['userType'] === 'superuser'" :to="{name: 'Jobs'}"><i
                                class="sidebar-item-icon fa fa-wrench"></i>
                            <span v-if="checkUrl()" class="nav-label">{{$t('message.work')}}</span>    
                            <span v-else class="nav-label">{{$t('message.bkp')}}</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'Profile'}"><i class="sidebar-item-icon fa fa-user"></i>
                            <span class="nav-label">{{$t('message.profile')}}</span></router-link>
                    </li>
                    <li v-if="$store.getters.getAuth['userType'] === 'superuser'">
                        <router-link :to="{name: 'ApplicationSettings'}"><i class="sidebar-item-icon fa fa-tv"></i>
                            <span class="nav-label">{{$t('message.settings')}}</span></router-link>
                    </li>
                      <li v-if="$store.getters.getAuth['userType'] === 'superuser'">
                        <router-link :to="{name: 'Messaging'}"><i class="sidebar-item-icon fa fa-envelope"></i>
                            <span class="nav-label">{{$t('message.messaging')}}</span></router-link>
                    </li>
                </ul>
            </div>
        </nav>
        <!-- END SIDEBAR-->
    </div>
</template>

<script>
  export default {
    name: 'Sidebar',
    data () {  
      return {
          dashboardVisibleCraftsmen: false
      }
    },
    mounted () {
    },
    created(){
       this.get(this.apiPrefix, this.miscApiUrl, 'get-application-details/')
                .then(resp => {
                  this.dashboardVisibleCraftsmen = resp.data.dashboard_visible_craftsmen
                 // console.log(this.dashboardVisibleCraftsmen)   
            })
            .catch(err => {
                console.log(err)
            })

        this.checkUrl()    
        
    },
   
  }
</script>

<style>
    #sidebar {
        position: fixed;
    }
</style>
